import { useTranslation } from 'react-i18next'
import { Button, H3, Text } from '@/components/atoms'
import { verifyCodeImage } from '@/shared/assets'
import { useUnderConstruction } from './under-construction.hook'

export function UnderConstruction() {
  const { t } = useTranslation()
  const { goHome } = useUnderConstruction()

  return (
    <div
      className="flex flex-col items-center gap-6 px-6 py-10 text-center"
      data-testid="under-construction"
    >
      <img
        src={verifyCodeImage}
        alt=""
        aria-hidden
        className="h-auto w-full max-w-60"
      />
      <div className="flex max-w-sm flex-col gap-2">
        <H3 className="font-bold">{t('underConstruction.title')}</H3>
        <Text className="text-neutral-600">
          {t('underConstruction.description')}
        </Text>
      </div>
      <Button onClick={goHome} data-testid="under-construction-home">
        {t('underConstruction.goHome')}
      </Button>
    </div>
  )
}
